<template>
    <div class="animated fadeIn summary">

        <SearchForm
                v-if="dataStructure !== false"
                ref="cardSearchForm"
                caption="Recherche"
                @onSubmit="search"
                @onReset="reset"
                :structure="dataStructure">
        </SearchForm>

        <Request
                ref="request"
                :onRequestSuccess="requestSuccess"
                root="/report/commerce-summary">
            <slot slot="body">

                <h4 class="mt-2">{{Core.Definition.getDefinition("Sommaire")}}</h4>
                <b-row class="p-2">
                    <b-col>
                        <table width="100%">
                            <tr>
                                <td>
                                    {{Core.Definition.getDefinition("Nombre de participant")}}
                                </td>
                                <td width="30%">
                                    {{dataCount}}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{Core.Definition.getDefinition("Sous-Total")}}
                                </td>
                                <td width="30%">
                                    {{dataSubTotal}} $
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{Core.Definition.getDefinition("Total")}}
                                </td>
                                <td width="30%">
                                    {{dataTotal}} $
                                </td>
                            </tr>
                        </table>
                    </b-col>
                </b-row>
                <br/>
                <b-card no-body class="mb-3">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-btn block href="#" v-b-toggle.accordionLeague variant="light">{{Core.Definition.getDefinition("Par division")}}</b-btn>
                    </b-card-header>
                    <b-collapse id="accordionLeague" role="tabpanel">
                        <b-card-body>
                            <b-row>
                                <b-col>
                                    <table width="100%">
                                        <thead>
                                            <tr>
                                                <th>{{Core.Definition.getDefinition("Titre")}}</th>
                                                <th>{{Core.Definition.getDefinition("Participants")}}</th>
                                                <th>{{Core.Definition.getDefinition("Sous-total")}}</th>
                                                <th>{{Core.Definition.getDefinition("Total")}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="league in dataLeagues">
                                                <td>
                                                    {{league.title}}
                                                </td>
                                                <td>
                                                    {{league.count}}
                                                </td>
                                                <td width="30%">
                                                    {{league.subTotal}} $
                                                </td>
                                                <td width="30%">
                                                    {{league.total}} $
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-3">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-btn block href="#" v-b-toggle.accordionTeam variant="light">{{Core.Definition.getDefinition("Par équipe")}}</b-btn>
                    </b-card-header>
                    <b-collapse id="accordionTeam" role="tabpanel">
                        <b-card-body>
                            <b-row>
                                <b-col>
                                    <table width="100%">
                                        <thead>
                                            <tr>
                                                <th>{{Core.Definition.getDefinition("Titre")}}</th>
                                                <th>{{Core.Definition.getDefinition("Participants")}}</th>
                                                <th>{{Core.Definition.getDefinition("Sous-total")}}</th>
                                                <th>{{Core.Definition.getDefinition("Total")}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="team in dataTeams">
                                                <td>
                                                    {{team.title}}
                                                </td>
                                                <td>
                                                    {{team.count}}
                                                </td>
                                                <td width="30%">
                                                    {{team.subTotal}} $
                                                </td>
                                                <td width="30%">
                                                    {{team.total}} $
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-3">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-btn block href="#" v-b-toggle.accordionPC variant="light">{{Core.Definition.getDefinition("Par catégorie")}}</b-btn>
                    </b-card-header>
                    <b-collapse id="accordionPC" role="tabpanel">
                        <b-card-body>
                            <b-row>
                                <b-col>
                                    <table width="100%">
                                        <thead>
                                            <tr>
                                                <th>{{Core.Definition.getDefinition("Titre")}}</th>
                                                <th>{{Core.Definition.getDefinition("Participants")}}</th>
                                                <th>{{Core.Definition.getDefinition("Sous-total")}}</th>
                                                <th>{{Core.Definition.getDefinition("Total")}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="participantCategory in dataParticipantCategories">
                                                <td>
                                                    {{participantCategory.title}}
                                                </td>
                                                <td>
                                                    {{participantCategory.count}}
                                                </td>
                                                <td width="30%">
                                                    {{participantCategory.subTotal}} $
                                                </td>
                                                <td width="30%">
                                                    {{participantCategory.total}} $
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-3">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-btn block href="#" v-b-toggle.accordionPR variant="light">{{Core.Definition.getDefinition("Par produit")}}</b-btn>
                    </b-card-header>
                    <b-collapse id="accordionPR" role="tabpanel">
                        <b-card-body>
                            <b-row>
                                <b-col>
                                    <table width="100%">
                                        <thead>
                                            <tr>
                                                <th>{{Core.Definition.getDefinition("Titre")}}</th>
                                                <th>{{Core.Definition.getDefinition("Participants")}}</th>
                                                <th>{{Core.Definition.getDefinition("Sous-total")}}</th>
                                                <th>{{Core.Definition.getDefinition("Total")}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="product in dataProducts">
                                                <td>
                                                    {{product.title}}
                                                </td>
                                                <td>
                                                    {{product.count}}
                                                </td>
                                                <td width="30%">
                                                    {{product.subTotal}} $
                                                </td>
                                                <td width="30%">
                                                    {{product.total}} $
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-3">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-btn block href="#" v-b-toggle.accordionTS variant="light">{{Core.Definition.getDefinition("t-Shirt")}}</b-btn>
                    </b-card-header>
                    <b-collapse id="accordionTS" role="tabpanel">
                        <b-card-body>
                            <b-row>
                                <b-col>
                                    <table width="100%">
                                        <tr>
                                            <td>
                                                XX-Small
                                            </td>
                                            <td width="30%">
                                                {{dataTshirtSize.xxs}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                X-Small
                                            </td>
                                            <td width="30%">
                                                {{dataTshirtSize.xs}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Small
                                            </td>
                                            <td width="30%">
                                                {{dataTshirtSize.s}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Medium
                                            </td>
                                            <td width="30%">
                                                {{dataTshirtSize.m}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Large
                                            </td>
                                            <td width="30%">
                                                {{dataTshirtSize.l}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                X-Large
                                            </td>
                                            <td width="30%">
                                                {{dataTshirtSize.xl}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                XX-Large
                                            </td>
                                            <td width="30%">
                                                {{dataTshirtSize.xxl}}
                                            </td>
                                        </tr>
                                    </table>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-collapse>
                </b-card>


            </slot>
        </Request>
    </div>
</template>

<style>
    .summary table tr td {
        border-bottom: 1px #ddd solid;
        padding:5px;
    }

    .summary table tr:hover {
        font-weight: bold;
    }
</style>

<script>

    import Request from '../../../../components/Request'
    import SearchForm from '../../../../components/SearchForm'
    export default {
        name: 'ReportCommerceSummary',
        components: {
            Request,
            SearchForm
        },
        props: {
            searchArgs: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
        },
        mounted() {
            this.$refs.request.clearArgs()
            this.$refs.request.request()
        },
        data: function () {
            return {
                Core: window.Core,
                dataTshirtSize: {},
                dataLeagues: [],
                dataParticipantCategories: [],
                dataProducts: [],
                dataSeasons: [],
                dataTeams: [],
                dataCount: 0,
                dataSubTotal: 0,
                dataTotal: 0,
                dataStructure: false

            }
        },
        methods: {
            reset() {
                this.$refs.request.clearArgs()
                this.$refs.request.request()
            },
            search(form, fieldRefs, structure) {
                this.$refs.request.clearArgs()

                let search = []
                search.push({
                    key: 'start',
                    value: form.start
                })
                search.push({
                    key: 'end',
                    value: form.end
                })

                if (form.teamId !== null && form.teamId[0] !== undefined && form.teamId[0].value !== undefined) {
                    search.push({
                        key: 'teamId',
                        value: form.teamId[0].value
                    })
                }
                if (form.productId !== null && form.productId[0] !== undefined && form.productId[0].value !== undefined) {
                    search.push({
                        key: 'productId',
                        value: form.productId[0].value
                    })
                }
                if (form.seasonId !== null && form.seasonId[0] !== undefined &&  form.seasonId[0].value !== undefined) {
                    search.push({
                        key: 'seasonId',
                        value: form.seasonId[0].value
                    })
                }
                if (form.categoryId !== null && form.categoryId[0] !== undefined &&  form.categoryId[0].value !== undefined) {
                    search.push({
                        key: 'categoryId',
                        value: form.categoryId[0].value
                    })
                }
                if (form.leagueId !== null && form.leagueId[0] !== undefined &&  form.leagueId[0].value !== undefined) {
                    search.push({
                        key: 'leagueId',
                        value: form.leagueId[0].value
                    })
                }

                this.$refs.request.addArg('search', search, Core.Value.typeJSON)
                this.$refs.request.request()
            },
            requestSuccess(data) {
              if(data !== undefined) {
                  if (data.count !== undefined) {
                      this.dataCount = data.count
                  }
                  if (data.subTotal !== undefined) {
                      this.dataSubTotal = data.subTotal
                  }
                  if (data.total !== undefined) {
                      this.dataTotal = data.total
                  }
                  if (data.leagues !== undefined) {
                      this.dataLeagues = data.leagues
                  }
                  if (data.participantCategories !== undefined) {
                      this.dataParticipantCategories = data.participantCategories
                  }
                  if (data.orderProducts !== undefined) {
                      this.dataProducts = data.orderProducts
                  }
                  if (data.teams !== undefined) {
                      this.dataTeams = data.teams
                  }
                  if (data.tshirtSize !== undefined) {
                      this.dataTshirtSize = data.tshirtSize
                  }
              }

              if (this.dataStructure === false) {
                  this.dataStructure = {
                      rows: [
                          {
                              cols: [
                                  {
                                      fields: [
                                          {
                                              id: 'start'
                                          }
                                      ]
                                  },
                                  {
                                      fields: [
                                          {
                                              id: 'end'
                                          }
                                      ]
                                  }
                              ]
                          },
                          {
                              cols: [
                                  {
                                      fields: [
                                          {
                                              id: 'teamId'
                                          }
                                      ]
                                  },
                                  {
                                      fields: [
                                          {
                                              id: 'productId'
                                          }
                                      ]
                                  }
                              ]
                          },
                          {
                              cols: [
                                  {
                                      fields: [
                                          {
                                              id: 'categoryId'
                                          }
                                      ]
                                  },
                                  {
                                      fields: [
                                          {
                                              id: 'seasonId'
                                          }
                                      ]
                                  }
                              ]
                          },
                          {
                              cols: [

                                  {
                                      fields: [
                                          {
                                              id: 'leagueId'
                                          }
                                      ]
                                  },
                                  {}
                              ]
                          }
                      ],
                      fields: [
                          {
                              id: 'start',
                              type: 'date',
                              label: Core.Definition.getDefinition('Début'),

                          },
                          {
                              id: 'end',
                              type: 'date',
                              label: Core.Definition.getDefinition('Fin'),
                          },
                          {
                              id: 'productId',
                              type: 'multiSelect',
                              label: Core.Definition.getDefinition('Produit'),
                              value: null,
                              onSelect: function() {
                              },
                              options: data.selectOptions.productId
                          },
                          {
                              id: 'seasonId',
                              type: 'multiSelect',
                              label: Core.Definition.getDefinition('Saison'),
                              value: null,
                              onSelect: function() {
                              },
                              options: data.selectOptions.seasonId
                          },
                          {
                              id: 'categoryId',
                              type: 'multiSelect',
                              label: Core.Definition.getDefinition('Catégorie'),
                              value: null,
                              onSelect: function() {
                              },
                              options: data.selectOptions.categoryId
                          },
                          {
                              id: 'teamId',
                              type: 'multiSelect',
                              label: Core.Definition.getDefinition('Équipe'),
                              value: null,
                              onSelect: function() {
                              },
                              options: data.selectOptions.teamId
                          },
                          {
                              id: 'leagueId',
                              type: 'multiSelect',
                              isVisible: Core.Session.AuthUser.can('report_multiple_league'),
                              label: Core.Definition.getDefinition('Ligue'),
                              value: null,
                              onSelect: function() {
                              },
                              options: data.selectOptions.leagueId
                          }
                      ]
                  }
              }


            }
        }
    }
</script>
